export default import.meta.ROLLDOWN_FILE_URL_79hNfTxEZvtz$VFl5m3gcQ